export const CONNECT_PROJECT_QUERY_PARAMS = [
	'selectedItem=(^com.atlassian.plugins.atlassian-connect-plugin.*)',
];
